import { aiStyles as e } from "../../theme/theme.mjs";
import t from "react";
import { css as n, styled as r } from "styled-components";
import { jsx as i } from "react/jsx-runtime";
import { Slot as a } from "@radix-ui/react-slot";
//#region src/components/Button/Button.tsx
var o = n`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    border: 1px solid transparent;
    border-radius: ${({ theme: e }) => e.radii.md};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};
    white-space: nowrap;
    text-decoration: none;
    outline: none;
    position: relative;

    &:focus-visible {
        outline: 2px solid ${({ theme: e }) => e.colors.ring};
        outline-offset: 2px;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    /* Elegant purely CSS-driven ripple effect! */
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(circle, currentColor 10%, transparent 10.01%) no-repeat 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition:
            transform 0.5s,
            opacity 1s;
        pointer-events: none;
    }

    &:active::after {
        transform: scale(0, 0);
        opacity: 0.2;
        transition: 0s;
    }
`, s = {
	sm: n`
        height: 32px;
        padding: 0 ${({ theme: e }) => e.spacing(1)};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    `,
	md: n`
        height: 40px;
        padding: 0 ${({ theme: e }) => e.spacing(2)};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    `,
	lg: n`
        height: 48px;
        padding: 0 ${({ theme: e }) => e.spacing(2)};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.lg};
    `,
	icon: n`
        height: 42px;
        width: 42px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    `
}, c = {
	primary: n`
        background-color: ${({ theme: e }) => e.colors.primary};
        color: ${({ theme: e }) => e.colors.primaryForeground};
        border-color: ${({ theme: e }) => e.colors.primary};
        &:hover:not(:disabled) {
            background-color: ${({ theme: e }) => e.colors.primaryHover};
            border-color: ${({ theme: e }) => e.colors.primaryHover};
        }
    `,
	secondary: n`
        background-color: ${({ theme: e }) => e.colors.secondary};
        color: ${({ theme: e }) => e.colors.secondaryForeground};
        border-color: ${({ theme: e }) => e.colors.border};
        &:hover:not(:disabled) {
            background-color: ${({ theme: e }) => e.colors.secondaryHover};
        }
    `,
	destructive: n`
        background-color: ${({ theme: e }) => e.colors.destructive};
        color: ${({ theme: e }) => e.colors.destructiveForeground};
        border-color: ${({ theme: e }) => e.colors.destructive};
        &:hover:not(:disabled) {
            background-color: ${({ theme: e }) => e.colors.destructiveHover};
        }
    `,
	ghost: n`
        background-color: transparent;
        color: ${({ theme: e }) => e.colors.foreground};
        border-color: transparent;
        &:hover:not(:disabled) {
            background-color: ${({ theme: e }) => e.colors.accent};
        }
    `,
	outline: n`
        background-color: transparent;
        color: ${({ theme: e }) => e.colors.foreground};
        border-color: ${({ theme: e }) => e.colors.border};
        &:hover:not(:disabled) {
            background-color: ${({ theme: e }) => e.colors.accent};
        }
    `
}, l = r.button`
    ${o}
    ${({ $size: e }) => s[e]}
    ${({ $variant: e }) => c[e]}
    ${({ $fullWidth: e }) => e && n`
            width: 100%;
        `}
    ${({ $rounded: e, theme: t }) => e && n`
            border-radius: ${t.radii.full};
        `}
    ${({ $ai: t }) => t && e.buttonOutline}
`, u = t.forwardRef(({ variant: e = "primary", size: t = "md", fullWidth: n = !1, rounded: r = !1, asChild: o = !1, isLoading: s = !1, ai: c = !1, type: u, children: d, disabled: f, ...p }, m) => /* @__PURE__ */ i(l, {
	as: o && o ? a : "button",
	ref: m,
	$variant: e,
	$size: t,
	$fullWidth: n,
	$rounded: r,
	$ai: c,
	type: o ? u : u ?? "button",
	disabled: f || s,
	...p,
	children: s ? "Loading…" : d
}));
u.displayName = "Button";
//#endregion
export { u as Button };
